<template>
  <div class="resource-lib">
    <div class="iframe-wrapper">
      <iframe class="resource-iframe" src="https://rm.ulearning.cn/#/portal/17" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "resourceLib"
};
</script>

<style scoped>
.resource-lib {
  height: 100%;
  padding-bottom: 0;
}

.iframe-wrapper {
  position: relative;
  z-index: 2;
  height: 100%;
}

.resource-iframe {
  width: 100%;
  height: 100%;
}
</style>